module.exports = __webpack_public_path__ + "assets/img/blast_3.fa3e0f06.png";